import { gtmSendEvent } from "@wojo/analytics";
import { Tag } from "@wojo/ui";
import dayjs from "dayjs";
import React, { PropsWithChildren } from "react";
import { useDeparturesStepContext } from "../context/DeparturesStepContext";
export const DepartureHeaderFilterTags: React.FC = () => {
    const { filterStates, setFilterStates } = useDeparturesStepContext();

    const FilterItem: React.FC<
        PropsWithChildren<{ filterName: string; onClick: () => void }>
    > = ({ filterName, onClick, children }) => (
        <li>
            <Tag
                isDismissible
                accessibleDismissText={`Remove ${
                    filterShortNameMap[filterName] ?? filterName
                } filter`}
                onClick={onClick}
            >
                {children
                    ? children
                    : filterShortNameMap[filterName] ?? filterName}
            </Tag>
        </li>
    );

    const hasAnyFilters = !!(
        filterStates.filters?.length ||
        filterStates.tripTypes?.length ||
        filterStates.departureStartDate ||
        filterStates.departureEndDate
    );

    if (!hasAnyFilters) {
        return null;
    }

    return (
        <ul
            aria-label="Selected departure filters"
            style={{
                display: "flex",
                listStyle: "none",
                flexWrap: "wrap",
                marginBottom: "0",
                marginTop: "var(--g-spacing-md)",
                gap: "var(--g-spacing-sm) var(--g-spacing-md)",
                gridColumn: "1 / end",
            }}
        >
            {[...(filterStates.filters ?? [])].map((filterName) => (
                <FilterItem
                    key={filterName}
                    filterName={filterName}
                    onClick={async () => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "TRIP_BUILDER",
                                ga4_action: "FILTER_REMOVED",
                                filterType: "Trip Builder Tour Dates",
                                filteredBy:
                                    filterShortNameMap[filterName] ??
                                    filterName,
                            },
                        });
                        const facets = filterStates.filters?.filter(
                            (f: string) => f !== filterName,
                        );
                        setFilterStates({
                            filters: facets?.length ? facets : null,
                        });
                    }}
                />
            ))}
            {[...(filterStates.tripTypes ?? [])].map((filterName) => (
                <FilterItem
                    key={filterName}
                    filterName={filterName}
                    onClick={async () => {
                        const facets = filterStates.tripTypes?.filter(
                            (f: string) => f !== filterName,
                        );
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "TRIP_BUILDER",
                                ga4_action: "FILTER_REMOVED",
                                filterType: "Trip Builder Tour Dates",
                                filteredBy:
                                    filterShortNameMap[filterName] ??
                                    filterName,
                            },
                        });
                        setFilterStates({
                            tripTypes: facets?.length ? facets : null,
                        });
                    }}
                />
            ))}
            {(filterStates.departureStartDate ||
                filterStates.departureEndDate) && (
                <FilterItem
                    key="departureDate"
                    filterName="departureDate"
                    onClick={async () => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "TRIP_BUILDER",
                                ga4_action: "FILTER_REMOVED",
                                filterType: "Trip Builder Tour Dates",
                                filteredBy: "Departure Date",
                            },
                        });
                        setFilterStates({
                            departureEndDate: null,
                            departureStartDate: null,
                        });
                    }}
                >
                    {dayjs(filterStates.departureStartDate).format(
                        //if the start and end date are in the same year, only show the month and day
                        filterStates.departureEndDate &&
                            dayjs(filterStates.departureStartDate).year() ===
                                dayjs(filterStates.departureEndDate).year()
                            ? "MMM DD"
                            : "MMM DD, YYYY",
                    )}
                    {filterStates.departureEndDate &&
                        ` - ${dayjs(filterStates.departureEndDate).format(
                            "MMM D, YYYY",
                        )}`}
                </FilterItem>
            )}
        </ul>
    );
};
/**
 * Map of filter names to their short names to be used in tag pills
 */
const filterShortNameMap: Record<string, string> = {
    isOnSale: "Deals",
    status: "Book online",
    hasExtensionAvailable: "Extensions",
};
